<template>
  <b-container fluid>
       <b-row style="line-height: 20px">
           <b-col md="12">
               <iq-card>
                   <template v-slot:body>
                       <b-row>
                           <b-col md="3" class="text-center iq-border-r-5 " align-self="center">
                               <img class="img-thumbnail " v-if="items.url" style="width: 200px; height: 200px; border-radius: 50%" :src="items.url" alt="">
                           </b-col>
                           <b-col md="9">
                               <table style="line-height: 20px" class="table table-sm table-borderless">
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.name')}}</th>
                                       <td style="width: 30%">{{currentLocale === 'en'? items.trainee.name : items.trainee.name_bn}}</td>
                                       <th style="width: 20%">{{$t('elearning_config.organization')}}</th>
                                       <td style="width: 30%">{{currentLocale === 'en'? (items.trainee.org? items.trainee.org.org : '') : (items.trainee.org ? items.trainee.org.org_bn : '')}}</td>
                                   </tr>
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.gender')}}</th>
                                       <td style="width: 30%">{{Gender(items.trainee.gender )}}</td>
                                       <th style="width: 20%">{{$t('elearning_config.type')}}</th>
                                       <td style="width: 30%">{{currentLocale === 'en'? (items.trainee.org_type? items.trainee.org_type.organization_type : '') : (items.trainee.org_type ? items.trainee.org_type.organization_type_bn : '')}}</td>
                                   </tr>
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.date_of_birth')}}</th>
                                       <td style="width: 30%">{{items.trainee.dob | dateFormat}}</td>
                                       <th style="width: 20%">{{$t('elearning_config.education_qualification')}}</th>
                                       <td style="width: 20%"> <span v-if="items.trainee.qualification">{{currentLocale === 'en'? items.trainee.qualification.name : items.trainee.qualification.name_bn}}</span></td>
                                   <tr>
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.husband_fathers_name')}}</th>
                                       <td style="width: 30%">{{currentLocale === 'en'? items.trainee.husb_fatr_name : items.trainee.husb_fatr_name_bn}}</td>
                                       <th style="width: 20%">{{$t('application_management.designation')}}</th>
                                       <td style="width: 30%">
                                            {{ items.trainee.other_designation ? items.trainee.other_designation : (currentLocale === 'en' ? items.trainee.designation.designation : items.trainee.designation.designation_bn) }}
                                       </td>
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.mothers_name')}}</th>
                                       <td style="width: 30%">{{currentLocale === 'en'? items.trainee.mother_name : items.trainee.mother_name_bn}}</td>
                                       <th style="width: 20%">{{$t('elearning_config.nid')}}</th>
                                       <td style="width: 30%">{{$n(items.trainee.nid, { useGrouping: false })}}</td>
                                   </tr>
                                   <tr>
                                       <th style="width: 20%" >{{$t('globalTrans.email')}}</th>
                                       <td style="width: 30%">{{items.trainee.email}}</td>
                                       <th style="width: 20%" >{{$t('elearning_config.contact_no')}}</th>
                                       <td style="width: 30%">{{currentLocale == 'bn'? items.trainee.contact_no.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d]) : items.trainee.contact_no}}</td>
                                   </tr>
                                   <tr>
                                       <th style="width: 20%">{{$t('elearning_config.present_address')}}</th>
                                       <td style="width: 30%">{{ addressPresent(items.trainee)}}</td>
                                       <th style="width: 20%">{{$t('elearning_config.permanent_address')}}</th>
                                       <td style="width: 30%">{{ addressPermanent(items.trainee) }}</td>
                                   </tr>
                               </table>
                           </b-col>
                       </b-row>
                   </template>
                   </iq-card>
           </b-col>
           <b-col md="12">
                           <iq-card>
                               <template v-slot:body>
                                   <table class="table table-sm table-borderless">
                                       <tr>
                                           <th style="width: 20%">{{$t('elearning_config.training')}}</th>
                                           <td style="width: 30%">{{trainingName(items.training_title_id)}}</td>
                                           <th style="width: 20%">{{$t('globalTrans.fiscal_year')}}</th>
                                           <td style="width: 30%">{{fiscalYear(items.fiscal_year_id)}}</td>
                                       </tr>
                                       <tr>
                                           <th>{{$t('elearning_config.organization')}}</th>
                                           <td>{{currentLocale === 'en'? items.trainee.org.org : items.trainee.org.org_bn}}</td>
                                          <th>{{$t('elearning_config.type')}}</th>
                                           <td>{{currentLocale === 'en'? items.trainee.org_type.organization_type : items.trainee.org_type.organization_type_bn}}</td>
                                       </tr>
                                     <tr>
                                            <th>{{$t('elearning_config.circular_memo_no')}}</th>
                                            <td>{{circularPublication(items.circular_pub_id)}}</td>
                                            <th>{{$t('elearning_config.application_date')}}</th>
                                            <td>{{items.apply_date | dateFormat}}</td>
                                        </tr>
                                     <tr>
                                       <th>{{ $t('elearning_config.office')  }}</th>
                                       <td colspan="3">
                                         {{officName(items.office_id)}}
                                      </td>
                                     </tr>
                                     <tr>
                                            <th>{{$t('application_management.org_approve_attachment')}}</th>
                                            <td colspan="3">
                                              <!-- <a target="_blank" :href="trainingElearningServiceBaseUrl + 'download-attachment?file=/uploads/trainee/orgapprove/' + items.org_approve_attachment" title="Application Form">{{ items.org_approve_attachment }} <i class="ri-download-cloud-fill"></i></a> -->
                                              <a v-if="items.org_approve_attachment" target="_blank" class="btn btn-primary mr-2" :href="trainingElearningServiceBaseUrl + 'download-attachment?file=/uploads/trainee/orgapprove/' + items.org_approve_attachment" title="Application Form">{{$t('globalTrans.download')}}</a>
                                              </td>

                                        </tr>
                                   </table>
                               </template>
                           </iq-card>
                </b-col>
       </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
// import { routineDetailApi } from '../../api/routes'
// eslint-disable-next-line no-unused-vars
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { core } from '../../../../../config/pluginInit'
export default {
    props: ['items'],
    components: {
    },
    created () {
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
            dataArray: {
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                details: [],
                edit_id: ''
            }
        }
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    methods: {
        Gender (type) {
            if (type === 1) {
                return this.$t('externalUser.male')
            } else if (type === 2) {
                return this.$t('externalUser.female')
            } else {
                return this.$t('externalUser.other')
            }
        },
        fiscalYear (id) {
            const item = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        circularPublication (id) {
            const item = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === id)
           return item.text
        },
        trainingName (id) {
            const item = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        orgType (id) {
            const item = this.$store.state.TrainingElearning.commonObj.organizationTypeList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        org (id) {
            const item = this.$store.state.TrainingElearning.commonObj.registeredOrgList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        gender (id) {
            const list = [
                { value: 1, text: this.$i18n.locale === 'en' ? 'Male' : 'পুরুষ' },
                { value: 2, text: this.$i18n.locale === 'en' ? 'Female' : 'মহিলা' },
                { value: 3, text: this.$i18n.locale === 'en' ? 'Other' : 'অন্যান্য' }
            ]
            return list.find(item => item.value === id).text
        },
        addressPresent (data) {
            if (data.pre_area_id === 1) {
                return this.Word(data.pre_ward_id) + this.CityCorp(data.pre_city_corporation_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
            }
            if (data.pre_area_id === 2) {
                return this.Word(data.pre_ward_id) + this.Pouroshova(data.pre_paurasabha_id) + this.Upazilla(data.pre_upazila_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
            }
            if (data.pre_area_id === 3) {
                return this.Word(data.pre_ward_id) + this.Union(data.pre_union_id) + this.Upazilla(data.pre_upazila_id) + this.District(data.pre_district_id) + this.Division(data.pre_division_id)
            }
        },
        addressPermanent (data) {
            if (data.per_area_id === 1) {
                return this.Word(data.per_ward_id) + this.CityCorp(data.per_city_corporation_id) + this.District(data.per_district_id) + this.Division(data.per_division_id)
            }
            if (data.per_area_id === 2) {
                return this.Word(data.per_ward_id) + this.Pouroshova(data.per_paurasabha_id) + this.Upazilla(data.per_upazila_id) + this.District(data.per_district_id) + this.Division(data.per_division_id)
            }
            if (data.per_area_id === 3) {
                return this.Word(data.per_ward_id) + this.Union(data.per_union_id) + this.Upazilla(data.per_upazila_id) + this.District(data.per_district_id) + this.Division(data.per_division_id)
            }
        },
      officName (id) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.officeList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn : data.text_en
                }
            } else {
                return ''
            }
        },
        Division (id) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.divisionList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn : data.text_en
                }
            } else {
                return ''
            }
        },
        District (id) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.districtList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                }
            } else {
                return ''
            }
        },
        CityCorp (id = null) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.cityCorporationList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                }
            } else {
                return ''
            }
        },
        Pouroshova (id = null) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.pauroshobaList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                }
            } else {
                return ''
            }
        },
        Upazilla (id = null) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.upazilaList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                }
            } else {
                return ''
            }
        },
        Union (id = null) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.unionList.find(item => item.value === id)
                    return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                }
            } else {
                return ''
            }
        },
        Word (id = null) {
            if (id) {
                if (id > 0) {
                    const data = this.$store.state.commonObj.wardList.find(item => item.value === id)
                    if (data !== undefined) {
                        return this.$i18n.locale === 'bn' ? data.text_bn + ', ' : data.text_en + ', '
                    }
                }
            } else {
                return ''
            }
        }
    }
}

</script>
